import React from "react";
import { PopoutIcon } from "@bookingcom/bui-assets-react/streamline";
import { Banner, Card, HiddenVisually, Icon, ListItem, Text } from "@bookingcom/bui-react";
import Frame from "../Frame/index.js";
import { useDSABannerController } from "./useDSABanner.controller.js";
import { flights_funnel_dsa_condense_banner_mobile, useTrackDSACondenseBannerMobile } from "../../../utils/experiments/funnel/flights_funnel_dsa_condense_banner_mobile.js";
export default function DSABanner() {
    const view = useDSABannerController();
    useTrackDSACondenseBannerMobile(!(!view.shouldRender || view.isHiddenByDismiss));
    if (!view.shouldRender || view.isHiddenByDismiss) {
        return null;
    }
    const isCondensedBanner = !!flights_funnel_dsa_condense_banner_mobile.trackWithDefaultStage();
    if (isCondensedBanner) {
        return (React.createElement(Frame, { mb: 4, attributes: { "data-testid": "DSABanner" } },
            React.createElement(Card, { fill: true, variant: "highlighted" },
                React.createElement(ListItem, { attributes: {
                        target: "_blank",
                        "data-testid": "DSABanner_link",
                        "aria-describedby": "dsa_banner_link_description"
                    }, href: view.linkUrl, onClick: () => {
                        flights_funnel_dsa_condense_banner_mobile.goals.click();
                    }, verticalAlignment: "start", startSlot: React.createElement(Text, { color: "action", attributes: { "aria-hidden": true } },
                        React.createElement(Icon, { svg: PopoutIcon, size: "medium" })) },
                    React.createElement(Text, null, view.message)),
                React.createElement(HiddenVisually, null,
                    React.createElement("div", { id: "dsa_banner_link_description" }, view.linkLabel)))));
    }
    return (React.createElement(Frame, { mb: 4, attributes: { "data-testid": "DSABanner" } },
        React.createElement(Banner, { dismissible: true, closeAriaLabel: view.closeAriaLabel, text: view.message, onClose: view.onDismiss, attributes: { style: { zIndex: 0, position: "relative" } }, actions: [
                {
                    attributes: {
                        target: "_blank",
                        "data-testid": "DSABanner_link",
                        onClick: () => {
                            flights_funnel_dsa_condense_banner_mobile.goals.click();
                        }
                    },
                    href: view.linkUrl,
                    text: view.linkLabel
                }
            ] })));
}
